export class DayItem {
  constructor(
    dayOfWeekName: string,
    dayOfWeekNumber: number,
    dayOfWeekSummaryName: string,
    dayOfMonth: number,
    equivalentGregorian: string | undefined
  ) {
    this.dayOfWeekName = dayOfWeekName;
    this.dayOfWeekNumber = dayOfWeekNumber;
    this.dayOfWeekSummaryName = dayOfWeekSummaryName;
    this.dayOfMonth = dayOfMonth;
    this.equivalentGregorian = equivalentGregorian;
  }
  public dayOfWeekName: string;
  public dayOfWeekNumber: number;
  public dayOfWeekSummaryName: string;
  public dayOfMonth: number;
  public equivalentGregorian?: string;
  public inputValue?: number;
  public outputValue?: number;
  public isHoliday: boolean = false;
}
